import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=fc17da80&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=fc17da80&prod&scoped=true&lang=scss"
import style1 from "./Detail.vue?vue&type=style&index=1&id=fc17da80&prod&lang=scss"
import style2 from "./Detail.vue?vue&type=style&index=2&id=fc17da80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc17da80",
  null
  
)

export default component.exports